import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { FilterService } from 'src/app/services/filter.service';
import { forkJoin } from 'rxjs';
import { LocalStorageService } from '../../../services/local-storage.service';

@Component({
  selector: 'app-sankey-card',
  templateUrl: './sankey-card.component.html',
  styleUrls: ['./sankey-card.component.scss']
})
export class SankeyCardComponent implements OnInit {
static key = 100817;

  @Input("item") item: any;
  @Input("pageKey") pageKey: any;
  @Input("dynamic") dynamic!: any;
  @Output("onSizeChange") onSizeChange = new EventEmitter<any>();
  @ViewChild("SankeyChart", { static: true }) SankeyChart!: ElementRef;

  config: any;
  data: any;
  heading: any;
  isDataLoaded = false;
  triageTotaldata: any;
  reqSubcription: Subscription[] = [];
  private lastQueryKey: string | null = null;
  
  constructor(private filterService: FilterService, private httpClient: HttpClient, private apiService: ApiService,private localStorage: LocalStorageService) {
    this.reqSubcription.push(
      this.filterService.filterQuery.subscribe((query: any) => {
        this.loadApiData();
      })
    );
  }
  ngOnInit(): void {
    this.loadlineConfig();
    const observerone = new ResizeObserver((e: any) => {
      this.onSizeChange.emit(e[0].contentRect.height);
    });
    observerone.observe(this.SankeyChart.nativeElement);
   
   }

  loadlineConfig() {
    this.heading = this.item.config["report_heading"];
  }

  // loadApiData(reportType?: string) {
  //   const api = this.item.config["list_of_api"] || {};
  //   const totalApi = this.item.config["total_api"] || 200229;
  //   const endpoint = this.item.config?.["list_of_api_endpoint"] || '';

  //   if (!this.filterService.isEmptyObject(this.filterService.baseQuery)) {

  //     let obj: any = { 
  //       api_key: api?.api_key ? api.api_key : api 
  //     };

  //     let query = {
  //       ...this.filterService.baseQuery,
  //       ...obj,
  //       report_typ: this.filterService.report_type
  //     };

  //     // ------------------------------------------
  //     // 1) MAIN API CALL
  //     // ------------------------------------------
  //     this.reqSubcription.push(
  //       this.httpClient.post(
  //         `${this.apiService.apiBaseUrl}/${endpoint || this.apiService.executionUrl}`, 
  //         query
  //       ).subscribe((res: any) => {

  //         this.isDataLoaded = true;
  //         this.data = res ?? [];

  //       }, (err: any) => {

  //         console.log(err);
  //         this.data = [];
  //         this.isDataLoaded = true;
  //       })
  //     );

  //     const totalApiPayload = {
  //       api_key: totalApi,
  //       report_typ: this.filterService.report_type,
  //       ...this.filterService.baseQuery
  //     };

  //     this.reqSubcription.push(
  //       this.httpClient.post(
  //         `${this.apiService.apiBaseUrl}/${this.apiService.executionUrl}`,
  //         totalApiPayload
  //       ).subscribe((res: any) => {

  //         this.triageTotaldata = res ?? [];

  //       }, (err: any) => {
  //         this.triageTotaldata = [];
  //         console.log("Total API error", err);
  //       })
  //     );
  //   }
  // }


loadApiData() {
  let cfg = this.item.config;
  const api = this.item.config["list_of_api"] || {};
  let isTotalApiRequired = cfg['total_api_required']?.name == 'No' ? false : true;
  const totalApi = this.item.config["total_api"] || 200229;
  const endpoint = this.item.config?.["list_of_api_endpoint"] || 'PSS/get-pss-data';

  if (!this.filterService.isEmptyObject(this.filterService.baseQuery)) {

    let obj: any = { 
      api_key: api?.api_key ? api.api_key : api 
    };

    let query = {
      ...this.filterService.baseQuery,
      ...obj,
      report_typ: this.filterService.report_type
    };

    const queryKey = JSON.stringify(query) + '|' + String(isTotalApiRequired);
    if (queryKey === this.lastQueryKey) {
      return;
    }
    this.lastQueryKey = queryKey;

    const mainApi$ = this.httpClient.post(
      `${this.apiService.apiBaseUrl}/${endpoint || this.apiService.executionUrl}`,
      query
    );

    if (isTotalApiRequired) {
      const totalApiPayload = {
        api_key: totalApi,
        report_typ: this.filterService.report_type,
        ...this.filterService.baseQuery
      };

      const totalApi$ = this.httpClient.post(
        `${this.apiService.apiBaseUrl}/${endpoint || this.apiService.executionUrl}`,
        totalApiPayload
      );

      this.reqSubcription.push(
        forkJoin([mainApi$, totalApi$]).subscribe(
          ([mainRes, totalRes]) => {
            this.data = mainRes ?? [];
            this.triageTotaldata = totalRes ?? [];
            this.localStorage.set('totalTriaged', this.triageTotaldata);
            this.isDataLoaded = true;
          },
          (err) => {
            console.log("API Error", err);
            this.data = [];
            this.triageTotaldata = [];
            this.isDataLoaded = true;
          }
        )
      );
    } else {
      this.reqSubcription.push(
        mainApi$.subscribe(
          (mainRes: any) => {
            this.data = mainRes ?? [];
            this.triageTotaldata = [];
            this.isDataLoaded = true;
          },
          (err) => {
            console.log("API Error", err);
            this.data = [];
            this.triageTotaldata = [];
            this.isDataLoaded = true;
          }
        )
      );
    }
  }
}

  ngOnDestroy(): void {
    this.reqSubcription.forEach(res => res.unsubscribe())
    this.localStorage.remove('totalTriaged');
  }
}

